var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center mt-4 mb-4"},[_c('aha-antd-button',{attrs:{"underline":true,"submitting":_vm.isLoadingDismissAll,"variant":"text-link"},on:{"click":function($event){return _vm.dismissAllMisspellsAction()}}},[_c('span',[_vm._v(_vm._s(_vm.$i18nPresenter.t('Dismiss all')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }